import { useEffect, useReducer } from 'react';
import { getIPGeolocation } from 'api/ipapi';

const LOADED_BY_NAVIGATOR = 'LOADED_BY_NAVIGATOR';
const LOADED_BY_IP_API = 'LOADED_BY_IP_API';

const filtersReducer = (reducerState, { type, payload }) => {
    switch (type) {
        case LOADED_BY_IP_API:
            return {
                ...reducerState,
                country: payload.country,
                state: payload.state,
                coordinates: payload.coordinates,
            };
        case LOADED_BY_NAVIGATOR:
            return {
                ...reducerState,
                coordinates: payload.coordinates,
            };

        default:
            return reducerState;
    }
};

export const useGeolocation = (geolocationActivated = true) => {
    const [{ country, state, coordinates }, dispatch] = useReducer(filtersReducer, {
        country: null,
        state: null,
        coordinates: { latitude: null, longitude: null },
    });

    useEffect(() => {
        if (!geolocationActivated) return;
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    // Success: the user has accepted
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;
                    dispatch({
                        type: LOADED_BY_NAVIGATOR,
                        payload: { coordinates: { latitude, longitude } },
                    });
                },
                error => {
                    // Handling errors or refusals
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                        case error.POSITION_UNAVAILABLE:
                        case error.TIMEOUT:
                        default:
                            getIPGeolocation().then(res => {
                                dispatch({ type: LOADED_BY_IP_API, payload: { ...res.data } });
                            });
                            break;
                    }
                }
            );
        } else {
            getIPGeolocation().then(res => {
                dispatch({ type: LOADED_BY_IP_API, ...res.data });
            });
        }
    }, [geolocationActivated]);
    return { country, state, coordinates };
};
